module.exports = __webpack_public_path__ + "img/1c01409.png";